import React, { useState, useRef, useEffect } from 'react';

/**
 * 공통 드롭다운 컴포넌트 (M_TCS_BASIC 정렬 메뉴 / WOR_BASIC_02 공정명 등 공통 사용)
 * @param {Array<{ value: string, label?: string, name?: string }>} options - 옵션 목록 (label 또는 name 사용)
 * @param {string} value - 선택된 값
 * @param {function(string)} onChange - 선택 시 호출 (value 전달)
 * @param {string} [placeholder='선택하세요'] - 미선택 시 버튼에 표시할 텍스트
 * @param {string} [triggerClassName] - 트리거 버튼 className
 * @param {string} [selectedOptionClassName] - 선택된 옵션에 적용할 className (예: 'bg-primary/10 text-primary')
 * @param {string} [menuClassName] - 드롭다운 메뉴 컨테이너 className
 * @param {boolean} [fullWidth=true] - true면 left-0 right-0, false면 right-0 (정렬순 등)
 */
function Dropdown(props) {
  const {
    options = [],
    value,
    onChange,
    placeholder = '선택하세요',
    triggerClassName = '',
    selectedOptionClassName = 'bg-primary/10 text-primary',
    menuClassName = '',
    fullWidth = true,
  } = props;

  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const HandleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', HandleClickOutside);
      document.addEventListener('touchstart', HandleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', HandleClickOutside);
      document.removeEventListener('touchstart', HandleClickOutside);
    };
  }, [open]);

  const GetOptionLabel = (item) => item?.label ?? item?.name ?? '';

  const selectedOption = options.find((opt) => (opt.value ?? '') === (value ?? ''));

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex w-full items-center justify-between px-4 text-left transition-all outline-none ${triggerClassName}`}
      >
        <span className={value ? 'text-[16px] text-slate-900' : 'text-[16px] text-slate-400'}>
          {selectedOption ? GetOptionLabel(selectedOption) : placeholder}
        </span>
        <span
          className={`material-symbols-outlined text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`}
        >
          expand_more
        </span>
      </button>
      {open && (
        <div
          className={`absolute top-full z-10 mt-1 max-h-48 overflow-y-auto rounded-lg border border-slate-200 bg-white py-1 shadow-lg ${fullWidth ? 'left-0 right-0' : 'right-0 min-w-[88px]'} ${menuClassName}`}
        >
          {options.map((item) => {
            const itemValue = item.value ?? '';
            const isSelected = (value ?? '') === itemValue;
            return (
              <button
                key={itemValue || 'empty'}
                type="button"
                onClick={() => {
                  onChange?.(itemValue);
                  setOpen(false);
                }}
                className={`w-full px-3 py-2 text-left !text-[16px] font-medium ${isSelected ? selectedOptionClassName : 'text-slate-700'
                  }`}
              >
                {GetOptionLabel(item)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Dropdown;
